import { useState, useEffect } from 'react';

export const useItem = (document, uid) => {

    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState({});

    useEffect(() => {
        setLoading(true);
        const unsubscribe = document.onSnapshot(doc => {

            let data = { ...doc.data(), uid: doc.id };
            setItem(data);
            setLoading(false);

        }, error => {
            console.log("Error: ", error);
            setItem(null);
            setLoading(false);
        });
        return () => unsubscribe();
    }, [uid])

    return { loading, item };

}